import PsiCopyButton from "./PsiCopyButton.vue";

export default PsiCopyButton;
